<mat-card class="mat-elevation-z0">
	<mat-card-title>
		Search Help Texts
		<mat-icon *ngIf="isLoading">
			<mat-spinner diameter="20"> </mat-spinner>
		</mat-icon>
	</mat-card-title>
	<mat-divider> </mat-divider>

	<div *ngIf="!isLoading && helpTexts && helpTexts.length > 0" class="margin-top-md" #res>
		<div class="row">
			<mat-form-field class="col-lg-12">
				<mat-label>
					Filter
				</mat-label>
				<input matInput id="filter" name="filter" type="string" [(ngModel)]="filter"
					(ngModelChangeDebounced)="setFilter()" />
			</mat-form-field>
		</div>

		<div class="margin-top-sm table-responsive">
			<mat-table [dataSource]="tableDataSource" class="mat-elevation-z1" matSort
				(matSortChange)="announceSortChange($event)">

				<ng-container matColumnDef="EDIT">
					<mat-header-cell *matHeaderCellDef> </mat-header-cell>
					<mat-cell *matCellDef="let element">
						<button type="icon" mat-icon-button color="primary" (click)="openDialogEdit(element)"
							matTooltip="Edit Help Text" aria-label="Edit Help Text">
							<mat-icon>edit</mat-icon>
						</button>

						<preview-help-text-btn [helpText]="element" [disabled]="!element.modifiedBy"
							matTooltip="Preview Help Text" aria-label="Preview Help Text"></preview-help-text-btn>

						<confirm-popover [type]="'button'" [buttonType]="'mini-icon'" [icon]="'delete'"
							[buttonTxt]="'Delete Help Text'"
							[popoverMsg]="'Are you sure you want to delete this Help Text?'" [color]="'warn'"
							(onConfirm)="deleteHelpText(element)" [tooltip]="'Delete Help Text'">
						</confirm-popover>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="modifiedDate">
					<mat-header-cell *matHeaderCellDef mat-sort-header> Modified Date </mat-header-cell>
					<mat-cell *matCellDef="let element">
						{{element.modifiedDate | simpleDateTime}}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="modifiedBy">
					<mat-header-cell *matHeaderCellDef mat-sort-header> Modified By </mat-header-cell>
					<mat-cell *matCellDef="let element">
						{{element.modifiedBy}}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="id">
					<mat-header-cell *matHeaderCellDef mat-sort-header> ID </mat-header-cell>
					<mat-cell *matCellDef="let element"> {{element.id}} </mat-cell>
				</ng-container>

				<ng-container matColumnDef="routeUrls[0]">
					<mat-header-cell *matHeaderCellDef mat-sort-header> Routes </mat-header-cell>
					<mat-cell *matCellDef="let element">
						<div class="row">
							<div class="col-12">
								<div class="row" *ngFor="let url of element.routeUrls">
									<a class="col-12" [routerLink]="url" routerLinkActive="active"
										target="_blank">{{url}}</a>
								</div>
							</div>
						</div>
					</mat-cell>
				</ng-container>


				<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
				<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
			</mat-table>

		</div>

		<mat-paginator [length]="tableDataSource ? tableDataSource.filteredData.length : helpTexts.length"
			[pageSize]="pageSize"
			[pageSizeOptions]="[5, 10, 20, (tableDataSource && tableDataSource.data ? tableDataSource.data.length > 100 ? tableDataSource.data.length : 100 : 100)]"
			(page)="onPageChange($event)" showFirstLastButtons>
		</mat-paginator>
	</div>
</mat-card>